module.exports = __webpack_public_path__ + "img/beer_ios_802.png";